import React from 'react';
import './ChatMessages.css';

function ChatMessages({ messages = [] }) {
  return (
    <div className="chat-messages">
      {messages.length === 0 ? (
        <p className="chat-messages-empty">No messages yet. Start the conversation below.</p>
      ) : (
        messages.map(function (msg, i) {
          const isUser = msg.sender === 'user';
          return (
            <div
              key={i}
              className={
                'chat-message' +
                (isUser ? ' chat-message--user' : ' chat-message--agent')
              }
            >
              <div className="chat-message-inner">
                <span className="chat-message-sender">
                  {isUser ? 'You' : 'Clarity2Work Agent'}
                </span>
                <div className="chat-message-bubble">
                  <span className="chat-message-text">{msg.text}</span>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

export default ChatMessages;
